export default "__VITE_ASSET__fe9ac8f9__"